module.exports = "../../../../platform/assets/pageMainIcon/icon-renyuan-2-red.svg";